/** Lightweight pub/sub when tracked-request data may have changed (badge refresh). */

type Listener = () => void;

const listeners = new Set<Listener>();

export function subscribeRequestTrackingInvalidation(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyRequestTrackingInvalidation(): void {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      // ignore subscriber errors
    }
  });
}
